import de_general from './de/general.json'
import en_general from './en/general.json'
import en_help from './en/help.json'

export default {
  de: { ...de_general },
  en: { ...en_general, help: en_help }
}
